enum ReimbursementTreeFieldCategoryName {
  CredentialingExpense = 'Credentialing Expense',
  Miscellaneous = 'Miscellaneous',
}

enum CredentialingExpenseSubType {
  License = 'License',
  MiscellaneousMedicalOrLabWork = 'Miscellaneous Medical or Lab Work',
}

enum MiscellaneousSubType {
  Other = 'Other',
}

export { ReimbursementTreeFieldCategoryName, CredentialingExpenseSubType, MiscellaneousSubType };
